app.factory("GoogleMapService",
	["$timeout", function($timeout) {

		var googleMapList = {};

		/**
		 * Sisäiseen käyttöön Google Map -direktiiville.
		 * @param name
		 * @param mapObj
		 * @constructor
		 */
		this.Register = function(name, mapObj) {
			googleMapList[name] = mapObj;
		};

		/**
		 * Hakee google map -instanssin.
		 * Palauttaa mapin ja sen kontrollifunktiot.
		 *
		 * @param name
		 * @returns {{map: Object, controls: Object}}
		 * @constructor
		 */
		this.Get = function(name) {
			return googleMapList[name];
		};

		/**
		 * Sisäiseen käyttöön Google Map -direktiiville.
		 * @param name
		 * @param controls
		 * @constructor
		 */
		this.Unregister = function(name) {
			if(googleMapList.hasOwnProperty(name)) {
				delete googleMapList[name];
			}
		};

		return this;
	}]
);